import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { IoDocumentSharp } from "react-icons/io5"; // Icon for document
import { MdPictureAsPdf } from "react-icons/md"; // Icon for PDF
import { FaFileExcel, FaFilePowerpoint, FaFileWord, FaFileImage } from "react-icons/fa"; // Icons for Excel, PowerPoint, Word, and Image
import { AiOutlineFileText } from "react-icons/ai"; // Icon for text files
import jsPDF from "jspdf";

const DisplayExitsCandidateDetails = () => {
  const [documents, setDocuments] = useState([]);
  const [cookies, , removeCookie] = useCookies(["userid", "authToken"]);
  const [userDetails, setUserDetails] = useState(null); // Store user details (Name, Employee ID)
  const navigate = useNavigate();
 const [isLoading, setIsLoading] = useState(true); // Track API data loading

  useEffect(() => {
    if (!cookies.authToken) {
      navigate("/SignInExitsCandidate");
    } else {
      fetchDocument();
      fetchUserDetails(); // Fetch user details like Name and Employee ID
    }
  }, [cookies.authToken, navigate]);

  const fetchDocument = async () => {
    try {
      const userid = cookies.userid;

      if (!userid) {
        console.error("User ID is not defined in cookies.");
        return;
      }

      const response = await fetch(`http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/ExitsDocuments/${userid}`);
      if (!response.ok) throw new Error("Failed to fetch document details");

      const data = await response.json();
      setDocuments(data);
    } catch (error) {
      console.error("Error fetching document details:", error);
    }
    finally {
      setIsLoading(false); // Data fetching completed
    }
  };

  const fetchUserDetails = async () => {
    try {
      const userid = cookies.userid;
      if (!userid) return;

      const response = await fetch(` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/ExitCandidate/${userid}`);
      if (!response.ok) throw new Error("Failed to fetch user details");

      const data = await response.json();
      setUserDetails(data); // Assuming `data` contains the user details
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  const downloadFile = async (fileUrl, fileName) => {
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("download", fileName); // Force download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const downloadImageAsPDF = async (imageUrl, fileName) => {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const reader = new FileReader();

      reader.onload = function (e) {
        const imgData = e.target.result;
        const doc = new jsPDF();
        const img = new Image();

        img.src = imgData;
        img.onload = function () {
          const pdfWidth = doc.internal.pageSize.getWidth() - 20; // Margin
          const pdfHeight = doc.internal.pageSize.getHeight() - 20; // Margin
          const ratio = Math.min(pdfWidth / img.width, pdfHeight / img.height);
          const width = img.width * ratio;
          const height = img.height * ratio;

          doc.addImage(imgData, "JPEG", 10, 10, width, height);
          doc.save(`${fileName}.pdf`);
        };
      };

      reader.readAsDataURL(blob);
    } catch (error) {
      console.error("Error converting image to PDF:", error);
    }
  };

  const handleLogout = () => {
    removeCookie("authToken", { path: "/" });
    navigate("/SignInExitsCandidate");
  };

  const getFileExtension = (filePath) => {
    return filePath.split(".").pop().toLowerCase(); // Get the file extension in lowercase
  };

  const renderFileIcon = (fileExtension) => {
    switch (fileExtension) {
      case "pdf":
        return <MdPictureAsPdf className="text-red-600" size={40} />;
      case "xls":
      case "xlsx":
        return <FaFileExcel className="text-green-600" size={40} />;
      case "ppt":
      case "pptx":
        return <FaFilePowerpoint className="text-orange-600" size={40} />;
      case "doc":
      case "docx":
        return <FaFileWord className="text-blue-600" size={40} />;
      case "txt":
        return <AiOutlineFileText className="text-gray-600" size={40} />;
      case "jpg":
      case "jpeg":
      case "png":
        return <FaFileImage className="text-gray-600" size={40} />;
      default:
        return <IoDocumentSharp className="text-gray-600" size={40} />;
    }
  };

  const handleDeleteDocument = async (docType) => {
    try {
      const userid = cookies.userid;
      const response = await fetch(
        ` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/ExitsDocuments/${userid}/${docType}`,
        {
          method: "DELETE",
        }
      );

      const text = await response.text(); // Get the response as text
      const data = JSON.parse(text);
      if (!response.ok) {
        console.error("Error response:", data);
        throw new Error(data.message || "Failed to delete document");
      }

      alert(`${docType} deleted successfully`);
      fetchDocument(); // Refresh the documents
    } catch (error) {
      console.error("Error deleting document:", error);
    }
  };

  const mapFNFStatus = (status) => {
    switch (status) {
      case "C":
        return "Complete";
      case "I":
        return "In Progress";
      case "P":
        return "Pending";
      default:
        return "Unknown";
    }
  };

  return (
    <div className="">
      <button
        onClick={handleLogout}
        className="bg-red-500 text-white px-3 py-2 rounded  mx-3 mt-3"
      >
        Logout
      </button>

     <div className="container mx-auto mt-2 p-6 px-10 bg-white rounded-lg shadow-lg w-3/4 md:w-1/2 lg:w-1/2">
     <h1 className="text-xl font-semibold mb-6 text-center text-indigo-600">
        Exit Candidate Documents 
      </h1>

      {isLoading ? (
          <p className="text-center text-blue-500 text-lg">Loading documents...</p>
        ) :  !userDetails || documents.length === 0? (
          <p className="text-center text-red-500 text-sm font-semibold">
            The ID has been created, HR will upload the documents as soon as possible. You have receive an email again after uploading.
          </p>
        ) : (
      <table className="min-w-full mt-3 table-auto border-collapse ">
      <thead>
          <tr className="bg-indigo-600 text-white">
            <th className="border px-6 py-2 text-base">Field</th>
            <th className="border px-6 py-2 text-base">Details</th>
           
          </tr>
        </thead>
        <tbody className="font-semibold text-gray-800">
          {/* User Details Row */}
          {userDetails && (
            <>
              <tr>
                <td className="border px-2 py-2 font-semibold  text-base">Name:</td>
                <td className="border px-2 py-2 text-base">{userDetails.userid.username}</td>
              </tr>
              <tr>
                <td className="border px-2 py-2 font-semibold  text-base">Employee ID:</td>
                <td className="border px-2 py-2 text-base">{userDetails.userid.EmployeeID}</td>
              </tr>
              <tr>
                <td className="border px-2 py-2 font-semibold  text-base">FNF Status:</td>
                <td className="border px-2 py-2 text-base">{mapFNFStatus(userDetails.FNF_Status)}</td>
              </tr>
            </>
          )}

          {/* Document Rows */}
          {documents.map((document, index) => {
            const documentFields = [
              { name: "Salary Slip", field: document.Salary_Slip, docType: "Salary_Slip" },
              { name: "Experience Letter", field: document.Experience_Letter, docType: "Experience_Letter" },
             
              { name: "Exit Statement", field: document.ExitStatement, docType: "ExitStatement" },
              { name: "Form 16", field: document.Form16, docType: "Form16" },
            ];

            return (
              <React.Fragment key={index}>
                {documentFields.map((doc, docIndex) => {
                  if (!doc.field) {
                    return (
                      <tr key={`${index}-${docIndex}`}>
                        <td className="border px-2 py-2 font-semibold  text-base">{doc.name}:</td>
                        <td className="border px-2 py-2 text-red-500 text-base ">Document will be uploaded soon</td>
                      </tr>
                    );
                  }

                  const filePath = ` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/ExitsEmployeeDocuments/${doc.field.replace("ExitsEmployeeDocuments/","")}`;
                  const fileExtension = getFileExtension(doc.field);
                  // console.log(filePath,"pppppp")

                  return (
                    <tr key={`${index}-${docIndex}`}>
                      <td className="border px-2 py-2  font-semibold  text-base">{doc.name}:</td>
                      <td className="border px-2 py-2  items-center text-base">
                        {renderFileIcon(fileExtension)}
                        <p
                          className="cursor-pointer text-blue-500 text-base underline ml-2 "
                          onClick={() => downloadFile(filePath, doc.name)}
                        >
                          Download
                        </p>
                      </td>
                    </tr>
                  );
                })}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>

        )}
     </div>
    </div>
  );
};

export default DisplayExitsCandidateDetails;
